import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { COMPOSED_CLAIMS } from 'constants/composedClaims';

import { selectIsClaimAllowed, selectIsSubCompanyUser } from 'store/auth/selectors';
import { selectLoanSubCompanyId } from 'store/loanApplications/selectors';

import { getInternalChatId, getTpoChatId } from '../../TeamChat.utils';

// Resolves which of a loan's chats the entity-reference row actions (DEV-5591 "Discuss in …") may
// target, from the SAME sources the loan chat drawer uses. A sub-company (broker) user is barred
// from the internal channel, so they only ever get the broker/TPO target; an internal user always
// gets the internal channel and additionally the broker channel when the loan belongs to a
// sub-company AND they hold the drawer's tpoChat.view claim (mirrors the drawer's availability
// gate, minus its participant check which needs initialized chat data — a non-claim participant
// simply doesn't get the row shortcut). Selectors only — unlike useEnsureChannelMessagesLoaded it
// fires no fetch, so it is safe to call per row.
const useLoanChatTargets = applicationId => {
  const isSubCompanyUser = useSelector(selectIsSubCompanyUser);
  const loanSubCompanyId = useSelector(selectLoanSubCompanyId);
  const hasTpoViewClaim = useSelector(selectIsClaimAllowed(COMPOSED_CLAIMS.TPO_CHAT_VIEW));

  return useMemo(() => {
    if (isSubCompanyUser) {
      return { internalChatId: null, tpoChatId: getTpoChatId(applicationId) };
    }

    return {
      internalChatId: getInternalChatId(applicationId),
      tpoChatId: loanSubCompanyId && hasTpoViewClaim ? getTpoChatId(applicationId) : null,
    };
  }, [applicationId, isSubCompanyUser, loanSubCompanyId, hasTpoViewClaim]);
};

export default useLoanChatTargets;
